export default {
    props: {
        value: {
            type: Array,
            default: () => []
        },
        showList: {
            type: Boolean,
            default: false
        },
        showDrop: {
            type: Boolean,
            default: true
        },
        auth: {
            type: String
        },
        baseURL: {
            type: String
        },
        dropzoneOptions: {
            type: Object,
            default: () => ({})
        },
        locale: {
            type: String,
            default: 'pl'
        },
        afterFileAdd: {
            type: Function,
            default: () => {}
        },
        allowDelete: {
            type: Boolean,
            default: false
        },
        beforeDeleteFn: {
            type: Function,
            default: () => Promise.resolve()
        },
        mediaListOptions: {
            type: Object,
            default: () => ({
                defaultMode: 'list',
                allowModeToggle: false,
            }),
            validator: (value) => ['list', 'tiles'].includes(value.defaultMode)
        }
    }
}